/**
 * Central Rollbar logging, usable from any module (not just Vue components).
 *
 * The single Rollbar instance for the app is created here. The Vue app root exposes
 * the same instance to components as `this.$rollbar` (see app.js), so `logError()`
 * here and `this.logError()` on the root both report through the one instance.
 *
 * Rollbar is not active in the "development" environment — the log methods below
 * safely do nothing when it is not active.
 */

import Rollbar from 'rollbar';
import config from "/config.js";
import globalStore from "/globalStore.js";


// Ref: https://docs.rollbar.com/docs/rollbarjs-configuration-reference
let rollbarInstance = null;

if (config.GetEnvironmentCode() != "development")
{
	rollbarInstance = new Rollbar({
		accessToken: 'd5acccd5094949f4a6e59640f839a03a0841d2eb4877e0e70bf52ddae49fe75019702afa677f25908ca56d54d77bbba9',
		captureUncaught: true,
		captureUnhandledRejections: true,
		payload: {
			environment: config.GetEnvironmentCode() + ":portal",
			person: {
				id: globalStore.state.currentUser.userId,
				username: globalStore.state.currentUser.displayName
				//email: globalStore.state.currentUser.userId
			}
		}
	});
}


const logging = {

	/**
	 * The shared Rollbar instance. `null` when logging is not active in this environment.
	 */
	rollbarInstance: rollbarInstance,


	logError(message, extraData)
	{
		if (rollbarInstance == null) return;	// Not active in this environment

		rollbarInstance.error(message, extraData);
	},


	logWarning(message, extraData)
	{
		if (rollbarInstance == null) return;	// Not active in this environment

		rollbarInstance.warn(message, extraData);
	},


	logInfo(message, extraData)
	{
		if (rollbarInstance == null) return;	// Not active in this environment

		rollbarInstance.info(message, extraData);
	}
};


export default logging;
